const ActScrm = [
  {
    path: "/page/:id",
    name: "scrmPageIndex",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/live/:id",
    name: "scrmLiveIndex",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/page/:id/:pager_id",
    name: "scrmPageIndex_1",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/live/:id/:pager_id",
    name: "scrmLiveIndex_1",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  // 微信浏览器绕过微信验证 主要是用在线上展会
  {
    path: "/page/:id/:pager_id/:identify",
    name: "scrmPageIndex_1",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/live/:id/:pager_id/:identify",
    name: "scrmLiveIndex_1",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/page/:id/:identify",
    name: "scrmPageIndex",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/live/:id/:identify",
    name: "scrmLiveIndex",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  // 线上展会结束
  {
    path: "/scrmlogin",
    name: "scrmLogin",
    component: (resolve) => require(["@/actscrm/scrmLogin.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/scrmuserform",
    name: "scrmUserForm",
    component: (resolve) => require(["@/actscrm/scrmUserForm.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/scrmselect",
    name: "scrmSelect",
    component: (resolve) => require(["@/actscrm/scrmSelect.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/scrmpage/index",
    name: "scrmpage",
    component: (resolve) => require(["@/actscrm/scrmPage.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/scrmpage/qcc",
    name: "scrmpageqcc",
    component: (resolve) =>
      require(["@/components/actscrm/qccact.vue"], resolve),
    meta: {
      title: "企查查会员验证",
    },
  },
  {
    path: "/livepage",
    name: "scrmLivePageIndex",
    component: (resolve) => require(["@/actscrm/livePage.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/scrm/transform",
    name: "scrmTransform",
    component: (resolve) => require(["@/actscrm/scrmTransform.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/scrmprize",
    name: "scrmPrize",
    component: (resolve) => require(["@/actscrm/scrmPrize.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/bbs/:id",
    name: "bbshomePage",
    component: (resolve) => require(["@/actscrm/bbs/bbshomePage.vue"], resolve),
    meta: {
      title: "",
      keepAlive: true,
    },
  },
  {
    path: "/actlogin/index",
    name: "actLogin",
    component: (resolve) => require(["@/actscrm/actLogin/login.vue"], resolve),
    meta: {
      title: "会员登录 - 电源网",
    },
  },
  {
    path: "/newpeople-login/index",
    name: "newpeopleLogin",
    component: (resolve) =>
      require(["@/actscrm/actLogin/newpeopleLogin.vue"], resolve),
    meta: {
      title: "会员登录 - 电源网",
    },
  },
  {
    path: "/actBasicInformation/index",
    name: "actBasicInformation",
    component: (resolve) =>
      require(["@/actscrm/actBasicInformation.vue"], resolve),
  },
  {
    path: "/staticpage/8",
    name: "NewBook",
    component: (resolve) => require(["@/act2021/newbook/index"], resolve),
    meta: {
      title: "【读者福利】免费领取张东辉课程",
    },
  },
  {
    path: "/staticpage/:id",
    name: "staticpage",
    component: (resolve) => require(["@/actscrm/scrmSinglePage.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/meeting",
    component: (resolve) => require(["@/actscrm/meeting.vue"], resolve),
    children: [
      {
        path: "sign/:id/:actid?",
        name: "scrmMeetLogin",
        component: (resolve) =>
          require(["@/actscrm/meeting/scrmMeetLogin.vue"], resolve),
        meta: {
          title: "电源网会议签到",
        },
      },
      {
        path: "improve/:id/:actid?",
        name: "scrmMeetImprove",
        component: (resolve) =>
          require(["@/actscrm/meeting/scrmMeetImprove.vue"], resolve),
        meta: {
          title: "完善信息",
        },
      },
      {
        path: "success/:id/:actid?",
        name: "scrmMeetSuccess",
        component: (resolve) =>
          require(["@/actscrm/meeting/scrmMeetSuccess.vue"], resolve),
        meta: {
          title: "签到成功",
        },
      },
      {
        path: "pager/:id",
        name: "scrmMeetPager",
        component: (resolve) =>
          require(["@/actscrm/meeting/scrmMeetPager.vue"], resolve),
        meta: {
          title: "会议问卷",
        },
      },
      {
        path: "exchange/:id",
        name: "scrmMeetAuthen",
        component: (resolve) =>
          require(["@/actscrm/meeting/scrmMeetAuthen.vue"], resolve),
        meta: {
          title: "资格验证",
        },
      },
      {
        path: "identif/:id",
        name: "scrmMeetIdentif",
        component: (resolve) =>
          require(["@/actscrm/meeting/scrmMeetIdentif.vue"], resolve),
        meta: {
          title: "资格验证",
        },
      },
      {
        path: ":id",
        name: "scrmMeetingIndex",
        component: (resolve) =>
          require(["@/actscrm/scrmActIntroduction.vue"], resolve),
        meta: {
          title: "活动中心",
        },
      },
      {
        path: ":id/:pager_id",
        name: "scrmMeetingIndex_1",
        component: (resolve) =>
          require(["@/actscrm/scrmActIntroduction.vue"], resolve),
        meta: {
          title: "活动中心",
        },
      },
    ],
  },
  {
    path: "/scrmAddWechat/:id?/:pager_id?",
    name: "scrmAddWechat",
    component: (resolve) => require(["@/actscrm/scrmPrize_none.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/scrmUserformOverdue",
    name: "scrmUserformOverdue",
    component: (resolve) =>
      require(["@/actscrm/scrmUserformOverdue.vue"], resolve),
    meta: {
      title: "完善信息",
    },
  },
  {
    path: "/scrmActLiveForm",
    component: (resolve) =>
      require(["@/actscrm/scrmActAndLive/index.vue"], resolve),
    meta: {
      title: "参与互动享双重好礼",
    },
    children: [
      {
        path: "index",
        name: "scrmActivityLive",
        component: (resolve) =>
          require(["@/actscrm/scrmActAndLive/home.vue"], resolve),
        meta: {
          title: "参与互动享双重好礼",
        },
      },
      {
        path: "check",
        name: "scrmActivityLiveCheck",
        component: (resolve) =>
          require(["@/actscrm/scrmActAndLive/check.vue"], resolve),
        meta: {
          title: "完善个人资料 领微信红包",
        },
      },
      {
        path: "improve",
        name: "scrmActivityLiveImprove",
        component: (resolve) =>
          require(["@/actscrm/scrmActAndLive/improve.vue"], resolve),
        meta: {
          title: "完善个人资料 领微信红包",
        },
      },
      {
        path: "questionnaire",
        name: "scrmActivityLiveQuestionnaire",
        component: (resolve) =>
          require(["@/actscrm/scrmActAndLive/questionnaire.vue"], resolve),
        meta: {
          title: "填写调查问卷 抽取精美礼品",
        },
      },
      {
        path: "finished",
        name: "scrmActivityLiveFinished",
        component: (resolve) =>
          require(["@/actscrm/scrmActAndLive/finished.vue"], resolve),
        meta: {
          title: "参与互动 享双重好礼",
        },
      },
      {
        path: "already",
        name: "scrmActivityLiveAlready",
        component: (resolve) =>
          require(["@/actscrm/scrmActAndLive/already.vue"], resolve),
        meta: {
          title: "填写调查问卷 抽取精美礼品",
        },
      },
    ],
  },
  {
    path: "/scrmMuster",
    component: (resolve) =>
      require(["@/actscrm/scrmMuster/index.vue"], resolve),
    meta: {
      title: "参与互动享双重好礼",
    },
    children: [
      {
        path: ":id",
        name: "scrmMuster",
        component: (resolve) =>
          require(["@/actscrm/scrmMuster/home.vue"], resolve),
        meta: {
          title: "参与互动享双重好礼",
        },
      },
      {
        path: "check/:id",
        name: "scrmMusterCheck",
        component: (resolve) =>
          require(["@/actscrm/scrmMuster/check.vue"], resolve),
        meta: {
          title: "完善个人资料 领微信红包",
        },
      },
      {
        path: "improve/:id",
        name: "scrmMusterImprove",
        component: (resolve) =>
          require(["@/actscrm/scrmMuster/improve.vue"], resolve),
        meta: {
          title: "完善个人资料 领微信红包",
        },
      },
      {
        path: "questionnaire/:id",
        name: "scrmMusterQuestionnaire",
        component: (resolve) =>
          require(["@/actscrm/scrmMuster/questionnaire.vue"], resolve),
        meta: {
          title: "填写调查问卷 抽取精美礼品",
        },
      },
      {
        path: "finished/:id",
        name: "scrmMusterFinished",
        component: (resolve) =>
          require(["@/actscrm/scrmMuster/finished.vue"], resolve),
        meta: {
          title: "参与互动 享双重好礼",
        },
      },
      {
        path: "already/:id",
        name: "scrmMusterAlready",
        component: (resolve) =>
          require(["@/actscrm/scrmMuster/already.vue"], resolve),
        meta: {
          title: "填写调查问卷 抽取精美礼品",
        },
      },
    ],
  },
  {
    path: "/scrmBinding",
    name: "scrmBinding",
    component: (resolve) => require(["@/actscrm/scrmBinding.vue"], resolve),
    meta: {
      title: "手机绑定",
    },
  },
  {
    path: "/scrmaddress/checkaddress",
    name: "checkaddress",
    component: (resolve) =>
      require(["@/actscrm/checkaddress/checkaddress.vue"], resolve),
    meta: {
      title: "地址验证",
    },
  },
  // NOTE:新增加的scrm活动排除电源网的
  {
    path: "/page2/:id",
    name: "scrmPageIndex2",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction2.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/page2/:id/:pager_id",
    name: "scrmPageIndex_1",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction2.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  // NOTE:活动
  {
    path: "/live2/:id",
    name: "scrmLiveIndex",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction2.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/live2/:id/:pager_id",
    name: "scrmLiveIndex2_1",
    component: (resolve) =>
      require(["@/actscrm/scrmActIntroduction2.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  // NOTE: 登陆页面
  {
    path: "/scrmlogin2",
    name: "scrmLogin2",
    component: (resolve) => require(["@/actscrm/scrmLogin2.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  // NOTE: 登陆页面

  {
    path: "/scrmuserform2",
    name: "scrmUserForm2",
    component: (resolve) => require(["@/actscrm/scrmUserForm2.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  // NOTE:一年完善信息
  {
    path: "/scrmUserformOverdue2",
    name: "scrmUserformOverdue2",
    component: (resolve) =>
      require(["@/actscrm/scrmUserformOverdue2.vue"], resolve),
    meta: {
      title: "完善信息",
    },
  },

  // NOTE:抽奖
  {
    path: "/scrmprize2",
    name: "scrmPrize2",
    component: (resolve) => require(["@/actscrm/scrmPrize2.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },

  // NOTE:表单
  {
    path: "/scrmpage2/index",
    name: "scrmpage2",
    component: (resolve) => require(["@/actscrm/scrmPage2.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/livepage2",
    name: "scrmLivePageIndex2",
    component: (resolve) => require(["@/actscrm/livePage2.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  // 自定义登录页面
  {
    path: "/customlogin/:act_id/:act_type/:userinfoflag",
    name: "customlogin",
    component: (resolve) => require(["@/actscrmcustom/scrmLogin.vue"], resolve),
    meta: {
      title: "登陆页面",
    },
  },
  // 自定义完善信息页面
  {
    path: "/scrmusercustomform",
    name: "scrmusercustomform",
    component: (resolve) =>
      require(["@/actscrmcustom/scrmUserForm.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  // live3 页面
  {
    path: "/live3/:id",
    name: "scrmLiveIndex",
    component: (resolve) => require(["@/actscrm/livePage3.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  {
    path: "/live3/:id/:pager_id",
    name: "scrmLivePageIndex3",
    component: (resolve) => require(["@/actscrm/livePage3.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
  // NOTE: 登陆页面
  {
    path: "/scrmlogin3",
    name: "scrmLogin3",
    component: (resolve) => require(["@/actscrm/scrmLogin3.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/scrmuserform3",
    name: "scrmUserForm3",
    component: (resolve) => require(["@/actscrm/scrmUserForm3.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  {
    path: "/scrmpage3/index",
    name: "scrmpage3",
    component: (resolve) => require(["@/actscrm/scrmPage3.vue"], resolve),
    meta: {
      title: "会员认证",
    },
  },
  // 泰克
  {
    path: "/tektronixlive",
    name: "tektronixliveIndex",
    component: (resolve) => require(["@/actscrm/tektronixlive.vue"], resolve),
    meta: {
      title: "活动中心",
    },
  },
];

export default ActScrm;
